import intl from 'react-intl-universal';
import AppDispatcher from '../dispatcher/AppDispatcher';
import CodeConstants from '../constants/CodeConstants';
import PackActions from '../actions/PackActions';
import Popup from 'react-popup';
import { EventEmitter } from 'events';

const CHANGE_EVENT = 'change';

let _codes = [];

function setCodes(codes) {
  if(codes.bundles || codes.products){
    codes.bundles = codes.bundles.sort()
    codes.products = codes.products.sort()
  } else {
    codes = codes.sort()
  }
  _codes = codes;
}

class CodeStoreClass extends EventEmitter {

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback)
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }

  getCodes() {
    return _codes;
  }

}

const CodeStore = new CodeStoreClass();

CodeStore.dispatchToken = AppDispatcher.register(action => {

  switch(action.actionType) {
    case CodeConstants.RECIEVE_CODES:
      if(action.codes.length>0 ||
         (action.codes.bundles && action.codes.bundles.length>0) ||
         (action.codes.products && action.codes.products.length>0)){
        setCodes(action.codes)
        CodeStore.emitChange()
      } else {
        Popup.create({
          content: intl.get('Brak zamówień możliwych do spakowania'),
          buttons: {
            right: [{text: intl.get('Wybierz inną paczkę'),
                    className: 'ok',
                    key: 'enter',
                    action: function () {
                      Popup.close()
                      PackActions.selectPack(false)
                    }}]
          }
        })
      }
      break

    case CodeConstants.RECIEVE_CODES_ERROR:
      Popup.alert(action.message);
      CodeStore.emitChange();
      break

    default:
  }

});

export default CodeStore;



// WEBPACK FOOTER //
// ./src/stores/CodeStore.js